namespace $.$$ {
	export class $exso_sheets_device extends $.$exso_sheets_device {
		@$mol_mem
		device_id() {
			return this.$.$mol_state_arg.value('device') || ''
		}

		@$mol_mem
		shifts() {
			const id = this.device_id()
			return super.shifts().filter(s => s.device === id)
		}

		@$mol_mem
		title() {
			return super.title().replace('{}', this.device_id())
		}
		columns_meta() {
			return this.$.$exso_sheets_shifts.columns()
		}
	}
}
